export const containsHtmlTags = (text) => {
    // Регулярное выражение для поиска HTML-тегов
    const htmlTagPattern = /<[^>]+>/;
    return htmlTagPattern.test(text);
}